import React, { PureComponent } from 'react';

import config from './AmountInput.config';

import { formatNumber, parseNumber } from '../utils';
import { MIN_AMOUNT, MAX_AMOUNT } from '../../constant';
import iconClose from '../../assets/close.svg';
import './AmountInput.less';

class AmountInput extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isFocus: false,
      // To check invalid input after user input valid value
      isEverValid: false,
      currentValue: '0',
      prevValue: '0',
    };
  }

  _onFocus = () => {
    this.setState({ isFocus: true });
  };

  _onBlur = () => {
    this.setState({ isFocus: false });
  };

  _forceUpdateState = value => {
    this.setState({ currentValue: formatNumber(value) });
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.currentValue !== this.state.currentValue) {
      this.props.input.onChange(parseNumber(this.state.currentValue));
    }
    if (prevProps.input.value !== this.props.input.value) {
      this._forceUpdateState(this.props.input.value);
    }
  }

  _onChange = event => {
    event.persist();
    const inputValue = event.target.value;
    const caretStart = event.target.selectionStart;

    const val = parseNumber(inputValue);
    let result;
    if (val <= 0) {
      result = 0;
    } else if (val > MAX_AMOUNT) {
      result = MAX_AMOUNT;
    } else {
      result = val;
    }

    const { length } = result.toString();
    const { length: valLength } = val.toString();

    this.setState(
      prevState => {
        let currentValue = result;

        if (parseNumber(prevState.currentValue) === 0) {
          if (length > caretStart) {
            currentValue /= 10;
          }
          if (valLength === 8 && val % 10 === 0) {
            currentValue = val / 10;
          }
        }
        return {
          currentValue: formatNumber(currentValue),
          prevValue: prevState.currentValue,
        };
      },
      () => {
        const { prevValue, currentValue } = this.state;
        this._checkInputIsEverValid(parseNumber(currentValue));

        const { length: currentLength } = currentValue;
        const { length: prevLength } = prevValue;

        let caretPos;

        if (currentLength === prevLength) {
          caretPos = caretStart;
        } else if (currentLength > prevLength) {
          caretPos = currentLength - prevLength + caretStart - 1;
        } else if (prevLength - currentLength === 2) {
          caretPos = caretStart - 1 >= 0 ? caretStart - 1 : 0;
        } else {
          caretPos = caretStart;
        }
        event.target.setSelectionRange(caretPos, caretPos);
      },
    );
  };

  _checkInputIsEverValid = input => {
    if (input >= MIN_AMOUNT) {
      this.setState({ isEverValid: true });
    }
  };

  _onClose = () => {
    document.getElementById('inputAmount').blur();
    this.setState(prevState => ({
      prevValue: prevState.currentValue,
      currentValue: '0',
    }));
  };

  render() {
    const {
      label,
      hint,
      intl: { formatMessage },
      meta: { touched, pristine, error },
    } = this.props;

    const { isEverValid, currentValue } = this.state;

    let errorMsg = '';
    const errorType = (error || '').split('.')[1];
    let inputState = '';
    if (
      (errorType === 'min' && (touched || isEverValid)) ||
      (!pristine && errorType === 'max')
    ) {
      inputState = 'error';
      errorMsg = error;
    } else if (this.state.isFocus) {
      inputState = 'active';
    }

    const errAmount = errorType === 'min' ? `${MIN_AMOUNT}` : `${MAX_AMOUNT}`;
    const isPlaceholder = currentValue === '0';

    return (
      <div className="AmountInput">
        <div className="input-wrapper">
          <span
            className={`semi-bold ${inputState}`}
            id="text_labelInputAmount"
          >
            {label}
          </span>
          <div className={`input-field ${inputState}`}>
            <span
              className="currency"
              style={{ color: isPlaceholder ? '#bfbfbf' : '#000' }}
            >
              Rp
            </span>
            <input
              id="inputAmount"
              type="text"
              inputMode="tel"
              maxLength="10"
              autoComplete="off"
              value={currentValue}
              placeholder={0}
              onFocus={this._onFocus}
              onBlur={this._onBlur}
              onChange={this._onChange}
              style={{ color: isPlaceholder ? '#bfbfbf' : '#000' }}
            />
            {currentValue && currentValue !== '0' && (
              <div onClick={this._onClose} id="btn_closeInputAmount">
                <img src={iconClose} alt="" />
              </div>
            )}
          </div>
          <span id="text_hintInputAmount" className={inputState}>
            {inputState === 'error'
              ? formatMessage({ id: errorMsg }) + errAmount
              : hint}
          </span>
        </div>
      </div>
    );
  }
}

AmountInput.propTypes = config.propTypes;
AmountInput.defaultProps = config.defaultProps;
AmountInput.componentDetail = config.componentDetail;
AmountInput.builderConfig = config.builderConfig;

export default AmountInput;
